import React, { PropsWithChildren } from 'react';
import styles from './StepContentWrapper.scss';

interface StepContentWrapperProps extends PropsWithChildren {
  className?: string;
}

export function StepContentWrapper({ children, className }: StepContentWrapperProps) {
  return <div className={className || styles.wrapper}>{children}</div>;
}
